import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import assembly from "../../images/assembly.jpg";
import "./Why.css";

const Why = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
        <span style={{ borderBottom: "5px solid gold", padding: "3px", display: "inline-block" }}>
          Why Us
        </span>
      </h1>
      <div className="WhyContent">
        {/* Side with stars icons and text description */}
        <div className="DescriptionContainer">
          <div className="DescriptionItem">
            <FontAwesomeIcon icon={faStar} color="gold" />
            <h2 style={{ marginLeft: "20px", marginBottom: "0" }}>
              State-of-the-Art Facilities
            </h2>
          </div>
          <div className="DescriptionItem">
            <FontAwesomeIcon icon={faStar} color="gold" />
            <h2 style={{ marginLeft: "20px", marginBottom: "0" }}>
              Experienced and Dedicated Faculty
            </h2>
          </div>
          <div className="DescriptionItem">
            <FontAwesomeIcon icon={faStar} color="gold" />
            <h2 style={{ marginLeft: "20px", marginBottom: "0" }}>
              Comprehensive Curriculum
            </h2>
          </div>
          <div className="DescriptionItem">
            <FontAwesomeIcon icon={faStar} color="gold" />
            <h2 style={{ marginLeft: "20px", marginBottom: "0" }}>
              Innovative Teaching Methods
            </h2>
          </div>
          <div className="DescriptionItem">
            <FontAwesomeIcon icon={faStar} color="gold" />
            <h2 style={{ marginLeft: "20px", marginBottom: "0" }}>
            Global Exposure
            </h2>
          </div>
          <div className="DescriptionItem">
            <FontAwesomeIcon icon={faStar} color="gold" />
            <h2 style={{ marginLeft: "20px", marginBottom: "0" }}>
              Extracurricular Activities
            </h2>
          </div>
          <div className="DescriptionItem">
            <FontAwesomeIcon icon={faStar} color="gold" />
            <h2 style={{ marginLeft: "20px", marginBottom: "0" }}>
              Parental Involvement
            </h2>
          </div>
          <div className="DescriptionItem">
            <FontAwesomeIcon icon={faStar} color="gold" />
            <h2 style={{ marginLeft: "20px", marginBottom: "0" }}>
            Career Guidance and Counseling
            </h2>
          </div>
          <div className="DescriptionItem">
            <FontAwesomeIcon icon={faStar} color="gold" />
            <h2 style={{ marginLeft: "20px", marginBottom: "0" }}>
              Focus on Values and Character Building
            </h2>
          </div>
          <div className="DescriptionItem">
            <FontAwesomeIcon icon={faStar} color="gold" />
            <h2 style={{ marginLeft: "20px", marginBottom: "0" }}>
              Student-Centered Learning Environment
            </h2>
          </div>
        </div>
        {/* Side with image */}
        <div className="ImageContainer">
          <img
            src={assembly}
            alt="description"
          />
        </div>
      </div>
    </div>
  );
};

export default Why;
